<template>
    <div class="lineReport">
        <div class="myChart" :id="lineDatas.id" style="width:100%;height:300px"></div>
    </div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'lineReport',
    props: ['lineDatas'],
    data() {
        return {}
    },
    mounted() {
        this.drawLine()
    },
    methods: {
        drawLine() {
            var myChart = echarts.init(document.getElementById(this.lineDatas.id))
            const [seriesList, colorList, legendList] = [[], [], []]
            const legendAddr = this.lineDatas.legendAddr ? this.lineDatas.legendAddr : 'center'
            const legendFormatter = this.lineDatas.formatter ? this.lineDatas.formatter : '{a} <br/>{b} : {c}人'
            for (let i = 0; i < this.lineDatas.data.length; i++) {
                colorList.push(this.lineDatas.data[i].color)
                legendList.push(this.lineDatas.data[i].title)
                seriesList.push({
                    symbolSize: 2, // 设定实心点的大小
                    smooth: this.lineDatas.data[i].smooth ? this.lineDatas.data[i].smooth : true,
                    symbol: this.lineDatas.data[i].symbol ? this.lineDatas.data[i].symbol : 'none', // 设定为实心点 none circle
                    name: this.lineDatas.data[i].title,
                    type: 'line',
                    data: this.lineDatas.data[i].list,
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                width: 2, // 折线宽度
                                color: this.lineDatas.data[i].color // 折线颜色
                            }
                        }
                    }
                })
            }
            var option = {
                color: colorList,
                title: {
                    text: this.lineDatas.title,
                    subtext: this.lineDatas.subText,
                    left: 'left',
                    textStyle: {
                        fontSize: 16
                    }
                },
                tooltip: {
                    // trigger: 'item',
                    trigger: 'axis',
                    formatter: legendFormatter
                },
                legend: {
                    left: legendAddr,
                    data: legendList
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    data: this.lineDatas.xdata
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        nameTextStyle: {
                            color: '#333'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: ['#f2f2f2']
                            }
                        }
                    }
                ],
                series: seriesList
            }
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option)
            //修改首次进入时图的宽度
            setTimeout(function(){
                myChart.resize();
            },200)
            window.addEventListener("resize", () => {
                myChart.resize();
            });
            // window.onresize = function () {
            //     myChart.resize()
            // }
        }
    },
    watch: {
        lineDatas: {
            handler: function() {
                this.drawLine()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.myChart{
}
</style>
